import {
	type TextColor,
	type StyledPlainButtonProps,
	type PlainButtonProps,
	Box,
} from '@bos/ui';

import { AppPlainButton } from './AppPlainButton';
import { AppText } from './AppText/AppText';

type PickedPlainButtonProps = Pick<
	PlainButtonProps,
	'onClick' | 'ref' | 'onKeyDown' | 'onFocus' | 'onBlur'
>;

type ExtendedAppPlainUnderlineButtonProps = PickedPlainButtonProps &
	StyledPlainButtonProps;

type AppPlainUnderlineButtonProps = ExtendedAppPlainUnderlineButtonProps & {
	text: string;
	spacingVertical?: boolean;
	spacingLeft?: boolean;
	textColor?: TextColor;
};

export const AppPlainUnderlineButton = ({
	text,
	spacingVertical,
	spacingLeft,
	textColor = 'action',
	...rest
}: AppPlainUnderlineButtonProps) => {
	return (
		<AppPlainButton {...rest}>
			<Box spacingVertical={spacingVertical} spacingLeft={spacingLeft}>
				<AppText color={textColor} variant={'b2'} underline>
					{text}
				</AppText>
			</Box>
		</AppPlainButton>
	);
};
